import React from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { ReferralExpertComponent, MessageRichCardType } from '#src/generated/graphql'
import { IdentityConsumer } from '#src/containers/Identity'
import { Image, Avatar } from '@deal/components'
import EmailCollectionModal from '#src/components/Share/EmailCollectionModal'
import ShortLinkModal from '#src/components/Share/ShortLinkModal'
import ShareExpertProfileModal from '#src/components/Share/ExpertProfileModal'
import styles from './styles.css'
import config from '#src/config'

enum Modal {
  Share,
  Email,
  Link
}

interface State {
  modal: Modal | null
  shortenedUrl: string | null
}

export default class FeedbackRequest extends React.PureComponent<MessageComponentProps, State> {
  constructor(props: MessageComponentProps) {
    super(props)

    this.state = { modal: null, shortenedUrl: null }

    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.generateShareUrl = this.generateShareUrl.bind(this)
  }

  public static handlesMessage(message: FirebaseMessage) {
    return (
      (message.parts[0].body.richCardType === MessageRichCardType.REFERRAL_REQUEST_FROM_EXPERT ||
        message.parts[0].body.type === 'expert-referral-requested') &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.expertId
    )
  }

  public handleOpenModal(modal: Modal) {
    this.setState({ modal })
  }

  public handleCloseModal() {
    this.setState({ modal: null })
  }

  public generateShareUrl(expertId: string, vanityId?: string | null, userId?: string) {
    const sharePath = `/experts/${vanityId ? vanityId : expertId}${
      userId ? `?referrer_id=${userId}` : ''
    }`
    return `${config.get('openGraph.url')}${sharePath}`
  }

  public render() {
    const expertId = this.props.message.parts[0].body.queryVariables.expertId
    const { modal } = this.state

    return (
      <IdentityConsumer>
        {({ myself }) => (
          <ReferralExpertComponent variables={{ vanityIdOrId: expertId }}>
            {({ data, loading }) => {
              if (loading) {
                return (
                  <MessageBubbleText
                    message={this.props.message}
                    myself={this.props.myself}
                    onLoaded={this.props.onLoaded}
                  >
                    Loading...
                  </MessageBubbleText>
                )
              } else if (data && data.findExpert) {
                const expert = data.findExpert

                const name = [expert.firstName, expert.lastName].filter(Boolean).join(' ')

                const category = expert.expertAttributes && expert.expertAttributes.categories[0]
                const banner = category && category.contentAssets.bannerImages[0]
                const categoryName = category && category.singularDisplayName

                const shareUrl = this.generateShareUrl(
                  expertId,
                  data.findExpert.vanityId,
                  myself ? myself.user.id : undefined
                )

                return (
                  <>
                    {modal === Modal.Share ? (
                      <ShareExpertProfileModal
                        onRequestClose={this.handleCloseModal}
                        onEmailShare={() => this.handleOpenModal(Modal.Email)}
                        onLinkShare={() => this.handleOpenModal(Modal.Link)}
                        shareUrl={shareUrl}
                        businessUserId={expert.id}
                      />
                    ) : modal === Modal.Email ? (
                      <EmailCollectionModal
                        onRequestClose={this.handleCloseModal}
                        expertId={expert.id}
                      />
                    ) : modal === Modal.Link ? (
                      <ShortLinkModal
                        shareUrl={shareUrl}
                        preferredDomain="curatedrefer.com"
                        onRequestClose={this.handleCloseModal}
                      />
                    ) : null}

                    <MessageBubble message={this.props.message}>
                      <div className={styles.hero}>
                        {banner && (
                          <Image
                            src={banner.imageUrl!}
                            width={384}
                            height={200}
                            imgixParams={{ fit: 'crop' }}
                            className={styles.heroImage}
                          />
                        )}
                        <div className={styles.overlay}>
                          {expert.expertProfile &&
                            expert.expertProfile.profilePhoto && (
                              <div className={styles.avatarContainer}>
                                <Avatar
                                  size={80}
                                  name={name}
                                  src={expert.expertProfile.profilePhoto.url}
                                />
                              </div>
                            )}
                          <div className={styles.name}>{name}</div>
                          <div className={styles.category}>Your {categoryName} Expert</div>
                        </div>
                      </div>
                      <div className={styles.cta} onClick={() => this.handleOpenModal(Modal.Share)}>
                        Share {expert.firstName}'s profile
                      </div>
                    </MessageBubble>
                  </>
                )
              } else {
                return (
                  <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                    Error loading message!
                  </MessageBubbleText>
                )
              }
            }}
          </ReferralExpertComponent>
        )}
      </IdentityConsumer>
    )
  }
}
